<template>
  <div class="container py-5">
    <!-- Heading -->
    <h2 class="heading text-center mb-5">Explore Our ICT Categories</h2>

    <!-- Categories Grid -->
    <div class="row g-4 justify-content-center">
      <div
        v-for="(category, index) in categories"
        :key="index"
        class="col-6 col-sm-6 col-md-4 col-lg-3"
      >
        <div
          class="modern-card text-center h-100"
          @click="goToCategory(category)"
        >
          <div class="icon-box">
            <i :class="category.icon"></i>
          </div>
          <h5 class="title mt-3">{{ category.name }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomePage",
  data() {
    return {
      categories: [
        { name: "Introduction to Computer", icon: "bi-laptop" },
        { name: "MS Office Package", icon: "bi-microsoft" },
        { name: "Internet & Network", icon: "bi-wifi" },
        { name: "Database Concepts", icon: "bi-database" },
        { name: "Programming", icon: "bi-code-slash" },
        { name: "Web Technology", icon: "bi-globe" },
        { name: "Graphic Design", icon: "bi-brush" },
        { name: "Cyber Security", icon: "bi-shield-lock" },
      ],
    };
  },
  methods: {
  goToCategory(category) {
    let routeName = "";

    switch (category.name) {
      case "Introduction to Computer":
        routeName = "IntroToComputer";
        break;
      case "MS Office Package":
        routeName = "MSOffice";
        break;
      case "Internet & Network":
        routeName = "InternetNetwork";
        break;
      case "Database Concepts":
        routeName = "DatabaseConcept";
        break;
      case "Programming":
        routeName = "ComputerProgramming";
        break;
      case "Web Technology":
        routeName = "WebTechnology";
        break;
      case "Graphic Design":
        routeName = "GraphicDesign";
        break;
      case "Cyber Security":
        routeName = "CyberSecurity";
        break;
    }

    if (routeName) {
      this.$router.push({ name: routeName });
    }
  },
}

};
</script>
<style scoped>
/* Heading */
.heading {
  font-weight: 800;
  color: #2563eb;
  letter-spacing: 1px;
  font-size: 2rem;
}

/* Modern Card */
.modern-card {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  border-radius: 18px;
  padding: 30px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

/* Card Hover */
.modern-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
  background: #ffffff;
}

/* Icon Styling */
.icon-box i {
  font-size: 2.8rem;
  color: #2563eb; /* Modern blue */
}

/* Title Styling */
.title {
  font-weight: 600;
  font-size: 1rem;
  color: #1e293b;
}

/* Mobile Responsive */
@media (max-width: 576px) {
  .heading {
    font-size: 1.6rem;
  }
  .icon-box i {
    font-size: 2.2rem;
  }
  .modern-card {
    padding: 20px 12px;
  }
}
</style>
